import { toast } from 'react-toastify';

export const alert = {
  success(message: string): void {
    toast(message, { type: 'success', position: 'top-center', hideProgressBar: true });
  },

  error(message: string): void {
    toast(message, { type: 'error', position: 'top-center', hideProgressBar: true });
  }
};
